import { css, styled } from '@mui/material/styles';

import LoaderSpinner from 'components/elements/LoaderSpinner';
import { renderTypographyStyles } from '../../../../../../mui/base/utils';

export const StyledForm = styled('form')(
  ({ theme }) => `
  width: 100%;
  
  margin:  ${theme.DS_spacing(['lg'])}  auto ${theme.DS_spacing(['xxl'])};
  .MuiCheckbox-root {
    margin-left: -${theme.DS_spacing(['xxs'])};
  }
`,
);

export const StyledButtonWrapper = styled('div')(
  ({ theme }) => `
  margin-top: ${theme.DS_spacing(['sm'])};
  margin-bottom: ${theme.DS_spacing(['md'])};
  width: 100%;

  button {
    width: 100% !important;
  }
`,
);

export const StyledLoaderSpinner = styled(LoaderSpinner)(
  ({ theme }) => `
  margin-top: ${theme.DS_spacing(['md'])};
`,
);

export const RichTextWrapper = styled('div')(
  ({ theme }) => `
  padding: 0;
  p {
    ${renderTypographyStyles(theme.typography.DS_copySmallRegular)};
  }

  a {
    text-decoration: underline;
    color: ${theme.DS_palette.buttons.enabled};
  }
`,
);

const dynamicFormBorderBoxStyles = ({ hasBorder, theme }) =>
  hasBorder &&
  css`
    padding: ${theme.DS_spacing(['xs'])};
    border: 1px solid ${theme.DS_palette.border.form};
  `;

export const FormBorderBox = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  align-items: center;
  ${dynamicFormBorderBoxStyles};
`;

export const StyledMarketingDisclaimer = styled('div')`
  p:first-of-type {
    margin-top: 0;
  }
`;

export const StyledServicePickUpWrapper = styled('div')(
  ({ theme }) => `
    margin: ${theme.DS_spacing(['md'])} 0;
    
    h2 {
       margin-bottom: ${theme.DS_spacing(['md'])};
    }
    h3 {
       margin: ${theme.DS_spacing(['md'])} 0;
    }
`,
);

export const StyledChosenLocation = styled('div')(
  ({ theme }) => `
   text-align: left;
   width: 100%;
   margin-top: -${theme.DS_spacing(['xxxs'])};
   padding-bottom: ${theme.DS_spacing(['sm'])};
   margin-left: 104px;
   color: ${theme.DS_palette.text.secondary};
   position: relative;
   z-index: -1;
   span > svg {
     position: absolute;
     top:-4px;
     left:-28px;
     fill: none;
     path {
       stroke:${theme.DS_palette.text.secondary};
     }
   
     )
   
   ${theme.breakpoints.up('lg')} {
       margin-left: 106px;
    }

`,
);
